import { ExtraMembership, ExtraMembershipRequest } from 'src/modules/member/models/extraMembership';
import AxiosInstance from './axios/interceptor';

const controller = 'ExtraMembership';

export const getExtraMemberships = (memberId: number) => {
  return AxiosInstance.get<ExtraMembership[]>(controller, { params: { memberId } });
};

export const createExtraMembership = (data: ExtraMembershipRequest) => {
  return AxiosInstance.post<{ memberId: number }>(controller, data);
};

export const cancelExtraMembership = (id: number) => {
  return AxiosInstance.put(`${controller}/${id}/Cancel`);
};
